import React from 'react';
import Collapse from '../../../../../hoc/Collapse/Collapse';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import AffichageGrapheAutomatiqueXT from '../../../../Graphe/AffichageGraphe/AffichageGrapheAutomatiqueXT';
import FormulaireConfirmerAlarme from './FormulaireConfirmerAlarme/FormulaireConfirmerAlarme';
import styles from './ProfilAlarmeClient.module.scss';

const ProfilAlarmeClient = ({ infoVue }) => {
  const informationAlarme = (
    <div className={[s.col_md_12, styles.ConteneurProfilVue].join(' ')}>
      <div className={styles.text_profil_vue}>
        <AffichageGrapheAutomatiqueXT
          key={infoVue.sensor_id + ' ' + infoVue.alarm_position}
          prefix={infoVue.prefix}
          derniereValeur={infoVue.alarm_value}
          engineering_unit={infoVue.engineering_unit}
          sensor_id={infoVue.sensor_id}
          position_in_sensor={infoVue.alarm_position}
          debut_date={parseInt(infoVue.alarm_start) - 24 * 60 * 60}
          fin_date={parseInt(infoVue.alarm_end) + 24 * 60 * 60}
        />
      </div>
    </div>
  );

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        <span className={styles.style}>
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            className="bi bi-info-circle-fill"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
        </span>
        <span className={styles.style}>
          {checkMot('alarme_id')} : {infoVue.alarm_id}
        </span>
      </div>
      <div className={s.container}>
        <Collapse expandText={checkMot('info_general')}>
          {informationAlarme}
        </Collapse>
        <Collapse
          showAdvanceParameters={true}
          expandText={checkMot('confirmer_alarme')}
        >
          <div>
            <FormulaireConfirmerAlarme preconfigurerAlarme={infoVue} />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ProfilAlarmeClient;
